<template>
    <app-ghost-mode>
        <!-- new sales rule -->
        <div class="row">
            <div class="col-12">
                <div class="jumbotron screen-center">
                    <form>
                        <div class="negotiate-header pt-3">
                            <h3 class="md-small-text text-center">New Sales Rule</h3>
                        </div>
                        <!-- Alert Messages -->
                        <dl v-if="msg !== ''" class="row mt-3 mb-n3">
                            <dd class="col-12">
                                <div :class="`alert alert-${color} text-center mb-n2 p-1`" role="alert">
                                    <i class="fas fa-exclamation-circle"></i> {{ msg }}
                                </div>
                            </dd>
                        </dl>
                        <div class="price-box">
                            <p class="mt-4 mb-2">Enter any name for this rule</p>
                            <div class="form-group">
                                <input v-model="ruleName" type="text" class="form-control no-lines bg-white" placeholder="(ex. BlackFriday85, NEWYEAR65OFF)">
                            </div>
                            <p class="mt-4 mb-2">Percentage to be discounted</p>
                            <div class="input-group">
                                <input v-model="rulePercentage" type="number" class="form-control no-lines bg-white" placeholder="(ex. 50, 75, 15, 100)">
                                <div class="input-group-prepend">
                                    <div class="input-group-text bg-light text-dark-green"><i class="fas fa-percentage mr-2"></i>OFF</div>
                                </div>
                            </div>
                            <p class="mt-4 mb-2">Briefly add a description of what this rule should do</p>
                            <div class="form-group">
                                <textarea v-model="ruleDescription" class="form-control no-lines bg-white" placeholder="(ex. give my buyers 90% off this black friday)" rows="5"></textarea>
                            </div>
                        </div>
                        <div class="text-center mt-4">
                            <button @click.prevent="createSaleFxn" class="loadn btn btn-dark-green">Create Sale Now</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </app-ghost-mode>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import GhostMode from '@/components/general/shared/GhostMode.vue'

export default {
    name: "NewSale",
    data() {
        return {
            ruleName: '',
            rulePercentage: null,
            ruleDescription: '',
            msg: '',
            color: 'danger',
        }
    },
    methods: {
        ...mapActions(['createSale']),
        createSaleFxn() {
            this.color = "danger"
            if(this.ruleName === ''){ this.msg = "A name is required for this sales rule!"; return }
            if(this.rulePercentage === null){ this.msg = "The percentage to be discounted is required!"; return }
            if(this.ruleDescription === ''){ this.msg = "A brief description of this rule is required!"; return }
            let salesObj = {
                userId: this.user._id,
                name: this.ruleName,
                percentage: this.rulePercentage,
                description: this.ruleDescription
            }
            this.createSale(salesObj)
            .then((data) => {
                this.color = !data.error ? "success" : "danger",
                this.msg = data.msg
                this.ruleName = ''
                this.rulePercentage = null
                this.ruleDescription = ''
            })
        }
    },
    computed: {
        ...mapGetters(['user']),
    },
    components: {
        appGhostMode: GhostMode,
    }
}
</script>